import { useStores } from "@client/store";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Path } from "@common/consts/Path";
import { config } from "@src/config";

export const useAuthorized = () => {
  const [counter, setCounter] = useState(1);
  const {
    client: {
      authStore: {
        isFetching,
        fetchAuth,
        isAuthorized,
        redirectToAccessDenied,
      },
    },
  } = useStores();

  const navigate = useNavigate();

  useEffect(() => {
    fetchAuth();
  }, [fetchAuth]);

  useEffect(() => {
    if (redirectToAccessDenied) {
      navigate(Path.TO_ACCESS_DENIED);
      return;
    }

    if (!isAuthorized && !isFetching && config.WEB_VERSION_URL) {
      if (counter === 5) {
        const redirectUrl = `${config.WEB_VERSION_URL}?modal=profile&redirect=${window.location.origin}`;
        window.location.replace(redirectUrl);
      } else {
        fetchAuth();
      }
      setCounter(counter + 1);
    }
  }, [isFetching, isAuthorized, redirectToAccessDenied]); // eslint-disable-line react-hooks/exhaustive-deps
};
